// src/components/NavBar.js - FINAL VERSION
import React from 'react';
// ✨ NEW: Import hooks and Link component from React Router
import { useLocation, Link } from 'react-router-dom';

// ✨ CORRECTED: Consolidated icon imports
import { HomeIcon, ExchangeIcon, AddIcon, ProfileIcon, SairIcon } from './Icons';

export default function NavBar({ onLogout }) {
    // ✨ NEW: Call the useLocation hook to get the current URL pathname
    const { pathname } = useLocation();

    const navItems = [
        { name: 'home', label: 'Início', path: '/home', icon: HomeIcon },
        { name: 'trades', label: 'Trocas', path: '/trades', icon: ExchangeIcon },
        { name: 'addItem', label: 'Anunciar', path: '/add-item', icon: AddIcon },
        { name: 'profile', label: 'Perfil', path: '/profile', icon: ProfileIcon },
    ];

    return (
        <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
            <div className="flex justify-around">
                {navItems.map(item => (
                    <Link
                        key={item.name}
                        to={item.path}
                        // ✨ CORRECTED: Use `pathname` to check for the active link
                        className={`flex-1 flex flex-col items-center justify-center py-2 text-sm transition ${
                            pathname === item.path ? 'text-green-600' : 'text-gray-500'
                        }`}
                    >
                        <item.icon className="w-6 h-6 mb-1" />
                        <span className="mt-1">{item.label}</span>
                    </Link>
                ))}
                
                <button
                    onClick={onLogout}
                    className="flex-1 flex flex-col items-center justify-center py-2 text-sm transition text-gray-500"
                >
                    <SairIcon className="w-6 h-6 mb-1" />
                    <span className="mt-1">Sair</span>
                </button>
            </div>
        </nav>
    );
}
